"use client";

import React, { useState, useMemo } from "react";
import { Area, AreaChart, CartesianGrid, XAxis, YAxis } from "recharts";
import { TrendingUp, Activity } from "lucide-react";
import { ChartContainer, ChartTooltip, ChartTooltipContent, type ChartConfig } from "@/components/ui/chart";
import { ToggleGroup, ToggleGroupItem } from "@/components/ui/toggle-group";
const monthlyEquity = [{
  month: "Start",
  date: "2021-05-02",
  equity: 1.0
}, {
  month: "May 2021",
  date: "2021-05-31",
  equity: 1.151159
}, {
  month: "Jun 2021",
  date: "2021-06-30",
  equity: 1.235474
}, {
  month: "Jul 2021",
  date: "2021-07-30",
  equity: 1.199195
}, {
  month: "Aug 2021",
  date: "2021-08-31",
  equity: 1.51163
}, {
  month: "Sep 2021",
  date: "2021-09-30",
  equity: 1.34788
}, {
  month: "Oct 2021",
  date: "2021-10-29",
  equity: 1.506883
}, {
  month: "Nov 2021",
  date: "2021-11-30",
  equity: 1.703658
}, {
  month: "Dec 2021",
  date: "2021-12-31",
  equity: 2.3492
}, {
  month: "Jan 2022",
  date: "2022-01-31",
  equity: 2.2063
}, {
  month: "Feb 2022",
  date: "2022-02-28",
  equity: 2.191996
}, {
  month: "Mar 2022",
  date: "2022-03-31",
  equity: 2.828938
}, {
  month: "Apr 2022",
  date: "2022-04-29",
  equity: 4.725777
}, {
  month: "May 2022",
  date: "2022-05-31",
  equity: 4.581098
}, {
  month: "Jun 2022",
  date: "2022-06-30",
  equity: 4.279842
}, {
  month: "Jul 2022",
  date: "2022-07-29",
  equity: 4.863232
}, {
  month: "Aug 2022",
  date: "2022-08-31",
  equity: 4.517857
}, {
  month: "Sep 2022",
  date: "2022-09-30",
  equity: 6.093751
}, {
  month: "Oct 2022",
  date: "2022-10-31",
  equity: 7.012097
}, {
  month: "Nov 2022",
  date: "2022-11-30",
  equity: 6.066445
}, {
  month: "Dec 2022",
  date: "2022-12-30",
  equity: 6.992294
}, {
  month: "Jan 2023",
  date: "2023-01-31",
  equity: 6.525335
}, {
  month: "Feb 2023",
  date: "2023-02-28",
  equity: 6.886602
}, {
  month: "Mar 2023",
  date: "2023-03-31",
  equity: 7.504931
}, {
  month: "Apr 2023",
  date: "2023-04-28",
  equity: 8.373879
}, {
  month: "May 2023",
  date: "2023-05-31",
  equity: 10.788298
}, {
  month: "Jun 2023",
  date: "2023-06-30",
  equity: 14.286139
}, {
  month: "Jul 2023",
  date: "2023-07-31",
  equity: 12.137118
}, {
  month: "Aug 2023",
  date: "2023-08-31",
  equity: 17.774665
}, {
  month: "Sep 2023",
  date: "2023-09-29",
  equity: 17.212928
}, {
  month: "Oct 2023",
  date: "2023-10-31",
  equity: 18.296122
}, {
  month: "Nov 2023",
  date: "2023-11-30",
  equity: 26.101205
}, {
  month: "Dec 2023",
  date: "2023-12-29",
  equity: 26.027468
}, {
  month: "Jan 2024",
  date: "2024-01-31",
  equity: 28.992709
}, {
  month: "Feb 2024",
  date: "2024-02-29",
  equity: 28.703158
}, {
  month: "Mar 2024",
  date: "2024-03-28",
  equity: 30.194237
}, {
  month: "Apr 2024",
  date: "2024-04-30",
  equity: 31.594045
}, {
  month: "May 2024",
  date: "2024-05-31",
  equity: 43.655092
}, {
  month: "Jun 2024",
  date: "2024-06-28",
  equity: 44.930489
}, {
  month: "Jul 2024",
  date: "2024-07-31",
  equity: 66.626484
}, {
  month: "Aug 2024",
  date: "2024-08-30",
  equity: 68.345794
}, {
  month: "Sep 2024",
  date: "2024-09-30",
  equity: 62.934678
}, {
  month: "Oct 2024",
  date: "2024-10-31",
  equity: 77.321631
}, {
  month: "Nov 2024",
  date: "2024-11-29",
  equity: 84.741372
}, {
  month: "Dec 2024",
  date: "2024-12-31",
  equity: 87.531301
}, {
  month: "Jan 2025",
  date: "2025-01-31",
  equity: 89.572454
}, {
  month: "Feb 2025",
  date: "2025-02-28",
  equity: 114.260626
}, {
  month: "Mar 2025",
  date: "2025-03-31",
  equity: 138.379607
}, {
  month: "Apr 2025",
  date: "2025-04-30",
  equity: 148.506253
}, {
  month: "May 2025",
  date: "2025-05-30",
  equity: 165.207257
}, {
  month: "Jun 2025",
  date: "2025-06-30",
  equity: 138.6589
}, {
  month: "Jul 2025",
  date: "2025-07-31",
  equity: 164.457914
}, {
  month: "Aug 2025",
  date: "2025-08-29",
  equity: 179.281806
}, {
  month: "Sep 2025",
  date: "2025-09-30",
  equity: 191.348216
}, {
  month: "Oct 2025",
  date: "2025-10-31",
  equity: 196.429539
}, {
  month: "Nov 2025",
  date: "2025-11-28",
  equity: 199.26328
}, {
  month: "Dec 2025",
  date: "2025-12-31",
  equity: 234.722143
}, {
  month: "Jan 2026",
  date: "2026-01-30",
  equity: 259.199591
}, {
  month: "Feb 2026",
  date: "2026-02-27",
  equity: 333.349452
}, {
  month: "Mar 2026",
  date: "2026-03-31",
  equity: 348.829537
}, {
  month: "Apr 2026",
  date: "2026-04-15",
  equity: 374.688877
}];
const chartConfig = {
  value: {
    label: "Total Return",
    color: "hsl(210, 100%, 55%)",
    icon: Activity
  }
} satisfies ChartConfig;
type Period = "all" | "2021" | "2022" | "2023" | "2024" | "2025" | "2026";
const YEARS: Period[] = ["2021", "2022", "2023", "2024", "2025", "2026"];
export default function EquityCurveVisualizer() {
  const [period, setPeriod] = useState<Period>("all");
  const filteredData = useMemo(() => {
    if (period === "all") {
      return monthlyEquity.map(d => ({
        ...d,
        value: (d.equity - 1) * 100
      }));
    }
    const yearStart = `${period}-01-01`;
    const yearEnd = `${period}-12-31`;
    const beforeYear = monthlyEquity.filter(d => d.date < yearStart);
    const baseEquity = beforeYear.length > 0 ? beforeYear[beforeYear.length - 1].equity : monthlyEquity[0].equity;
    const inYear = monthlyEquity.filter(d => d.date >= yearStart && d.date <= yearEnd);
    const anchor = {
      month: "Start",
      date: yearStart,
      equity: baseEquity,
      value: 0
    };
    return [anchor, ...inYear.map(d => ({
      ...d,
      value: (d.equity / baseEquity - 1) * 100
    }))];
  }, [period]);
  const endValue = filteredData[filteredData.length - 1]?.value || 0;
  return <section id="equity-curve-visualizer" className="dark bg-background text-foreground py-24 px-4 sm:px-8 lg:px-16 relative overflow-hidden">
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[800px] h-[400px] bg-primary/5 blur-[120px] rounded-full pointer-events-none" />

      <div className="max-w-7xl mx-auto relative z-10">
        <div className="flex flex-col lg:flex-row justify-between items-start lg:items-end mb-12 gap-6">
          <div>
            <div className="flex items-center gap-2 mb-3">
              <div className="p-2 bg-primary/10 rounded-md border border-primary/20">
                <TrendingUp className="w-5 h-5 text-primary" />
              </div>
              <h2 className="text-3xl md:text-4xl font-bold tracking-tight text-foreground">
                Backtest Performance
              </h2>
            </div>
            <p className="text-muted-foreground max-w-xl text-lg">Historical backtest results with compounding of Imperium Multi-Strategy on NASDAQ futures including commisions and slippage (May 2021 - Apr 2026).</p>

            <div className="mt-6 flex items-baseline gap-4">
              <span className={`text-4xl md:text-5xl font-mono font-semibold tracking-tighter ${endValue >= 0 ? "text-emerald-500" : "text-destructive"}`}>
                {endValue >= 0 ? "+" : ""}
                {endValue.toLocaleString(undefined, {
                maximumFractionDigits: 2,
                minimumFractionDigits: 2
              })}%
              </span>
              <span className="text-sm text-muted-foreground uppercase tracking-wider">
                {period === "all" ? "All Time" : `${period} Return`}
              </span>
            </div>
          </div>

          <div className="flex flex-col gap-3 w-full lg:w-auto">
            <div className="flex items-center justify-between gap-4 bg-card/50 backdrop-blur-sm py-1.5 px-3 rounded-lg border border-border/50 shadow-sm">
              <span className="text-sm font-medium text-muted-foreground uppercase tracking-wider">
                Period
              </span>
              <ToggleGroup type="single" value={period} onValueChange={value => {
              if (value) setPeriod(value as Period);
            }} className="justify-end flex-wrap">
                <ToggleGroupItem value="all" aria-label="Toggle All Time" className="px-3 py-2 text-sm data-[state=on]:bg-primary data-[state=on]:text-primary-foreground transition-all">
                  ALL
                </ToggleGroupItem>
                {YEARS.map(y => <ToggleGroupItem key={y} value={y} aria-label={`Toggle ${y}`} className="px-3 py-2 text-sm data-[state=on]:bg-primary data-[state=on]:text-primary-foreground transition-all">
                    {y}
                  </ToggleGroupItem>)}
              </ToggleGroup>
            </div>
          </div>
        </div>

        <div className="w-full h-[500px] bg-card/30 backdrop-blur-md border border-border/50 rounded-2xl p-4 sm:p-6 shadow-2xl relative">
          <ChartContainer config={chartConfig} className="w-full h-full">
            <AreaChart data={filteredData} margin={{
            top: 10,
            right: 10,
            left: 0,
            bottom: 0
          }}>
              <defs>
                <linearGradient id="fillValue" x1="0" y1="0" x2="0" y2="1">
                  <stop offset="5%" stopColor="hsl(210, 100%, 55%)" stopOpacity={0.3} />
                  <stop offset="95%" stopColor="hsl(210, 100%, 55%)" stopOpacity={0.0} />
                </linearGradient>
              </defs>

              <CartesianGrid vertical={false} stroke="var(--border)" strokeDasharray="4 4" opacity={0.4} />

              <XAxis dataKey="month" tickLine={false} axisLine={false} tickMargin={12} minTickGap={48} stroke="var(--muted-foreground)" fontSize={12} />

              <YAxis tickLine={false} axisLine={false} tickMargin={12} stroke="var(--muted-foreground)" fontSize={12} tickFormatter={value => `${value.toLocaleString(undefined, {
              maximumFractionDigits: 0
            })}%`} domain={["auto", "auto"]} width={80} />

              <ChartTooltip cursor={{
              stroke: "var(--border)",
              strokeWidth: 1,
              strokeDasharray: "4 4"
            }} content={<ChartTooltipContent className="bg-card/90 backdrop-blur-xl border-border/50 shadow-2xl rounded-xl p-3" labelFormatter={label => label} formatter={(value: number) => <div className="flex items-center gap-2">
                        <div className="w-2 h-2 rounded-full bg-primary shadow-[0_0_8px_var(--color-primary)]" />
                        <span className="font-mono font-semibold text-foreground text-lg">
                          {value >= 0 ? "+" : ""}
                          {value.toLocaleString(undefined, {
                  maximumFractionDigits: 2,
                  minimumFractionDigits: 2
                })}%
                        </span>
                      </div>} />} />

              <Area type="monotone" dataKey="value" stroke="hsl(210, 100%, 55%)" strokeWidth={3} fill="url(#fillValue)" animationDuration={1500} animationEasing="ease-out" />
            </AreaChart>
          </ChartContainer>
        </div>
      </div>
    </section>;
}